module.exports = __webpack_public_path__ + "img/icon-facebook.8c1c0338.svg";